export const toDate = value => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isFinite(date.getTime()) ? date : null;
};

const pad = value => String(value).padStart(2, "0");

export const formatDateTime = value => {
  const date = toDate(value);
  if (!date) return "Horário indisponível";
  return pad(date.getDate()) + "/" + pad(date.getMonth() + 1) + "/" + date.getFullYear() + " " +
    pad(date.getHours()) + ":" + pad(date.getMinutes()) + ":" + pad(date.getSeconds());
};

export const localTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone || "horário local";

export const formatElapsed = milliseconds => {
  const seconds = Math.max(0, Math.floor(milliseconds / 1000));
  const days = Math.floor(seconds / 86400);
  return (days ? days + "d " : "") + pad(Math.floor(seconds / 3600) % 24) + ":" +
    pad(Math.floor(seconds / 60) % 60) + ":" + pad(seconds % 60);
};

export const getWaitingState = (ticket, now = Date.now()) => {
  const recordedStart = toDate(ticket?.waitingSince);
  const start = recordedStart || toDate(ticket?.createdAt);
  const active = ticket?.status === "pending";
  const elapsed = active && start ? Math.max(0, now - start.getTime()) : 0;
  const level = !active || !start ? "unknown" : elapsed >= 15 * 60000 ? "long" : elapsed >= 5 * 60000 ? "medium" : "short";
  const estimated = active && Boolean(ticket?.waitingSinceEstimated || !recordedStart);
  const lowerBound = estimated && Boolean(recordedStart);
  return {
    active, start, elapsed, level, estimated, lowerBound,
    label: ({ short: "Espera recente", medium: "Atenção à espera", long: "Espera longa", unknown: "Aguardando" })[level],
    timer: start ? formatElapsed(elapsed) : "—",
    description: start ? (lowerBound ? "Tempo mínimo estimado para atendimento anterior à atualização. Referência: " : estimated ? "Tempo estimado com base no cadastro; início da espera não registrado. Referência: " : "Aguardando desde ") + formatDateTime(start) + " · " + localTimeZone() : "Início da espera indisponível",
  };
};

// Oldest queue entry is highest priority. Message activity never changes this order.
// Numeric ids provide the same stable tie-breaker as the database pagination.
export const compareWaitingPriority = (left, right) => {
  const leftStart = toDate(left?.waitingSince) || toDate(left?.createdAt);
  const rightStart = toDate(right?.waitingSince) || toDate(right?.createdAt);
  const leftTime = leftStart ? leftStart.getTime() : Infinity;
  const rightTime = rightStart ? rightStart.getTime() : Infinity;
  if (leftTime !== rightTime) return leftTime < rightTime ? -1 : 1;
  return Number(left.id) - Number(right.id);
};

export const sortWaitingTickets = tickets => [...tickets].sort(compareWaitingPriority);
